/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "colors_primary": "text-white border-al-petroleum bg-al-petroleum-600 hover:bg-al-petroleum-700 focus:bg-al-petroleum-600 active:bg-al-petroleum-800",
  "colors_secondary": "bg-white border-al-petroleum text-al-petroleum-600 hover:bg-al-petroleum-100 focus:bg-white active:bg-al-petroleum-200",
  "size_small": "px-3 gap-1 h-7.5 text-al-button-sm",
  "size_medium": "px-5 gap-2 h-9 text-al-button-md",
  "size_large": "px-5.5 gap-2 h-11.5 text-al-button-md",
  "variant_default": "border inline-flex items-center justify-center rounded-full outline-none focus:outline-none transition-all duration-200 ease-in-out",
  "colors_alternative": "text-white bg-al-korall-600 border-transparent border-2 hover:bg-al-korall-700 focus:bg-al-korall-700 focus:border-al-korall-300 active:bg-al-korall-800"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Button");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;